import { Fragment } from 'react';
import { useRouter } from 'next/router';
import Enllac from 'components/3catinfo/Enllac';
import Imatge from 'components/3catinfo/Imatge';
import { getUrlFriendly } from 'components/3catinfo/Enllac/RouteResolver';
import styles from './destacatVisualMinut.module.scss';
import Boto from 'components/3catinfo/Boto/Boto';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import Etiqueta from 'components/3catinfo/Etiqueta';
import Text from 'components/3catinfo/Text';
import Etiquetes from 'components/3catinfo/Etiquetes';
import EtiquetesEspecial from 'components/3catinfo/EtiquetesEspecial';
import { getDataUTC } from '@portal-internet/core';
import { getHora, getdataFormatadaBy } from 'utils/3catinfo/dateHelper';

const DataPublicacio = (props) => {
    const { isDirecte, mostrarData, date } = props;
    return !isDirecte && mostrarData && date ? (
        <span className={styles.dataDestacat}>{getdataFormatadaBy(date, '.')}</span>
    ) : (
        <></>
    );
};

const DestacatVisualMinut = (props) => {
    const { item, testId, estil, tema, mostrarData, marcatgeAudienciesClick, priorityImage, etiquetaEspecial = false } = props;
    const { id, titol, permatitle, imatges, data_publicacio, isDirecte, agrupacions, tags, autors, lloc, entrades } =
        item || props;
    const etiquetaEspecialBool = String(etiquetaEspecial).toLowerCase() === 'true';

    const router = useRouter();
    if (!titol) {
        return <></>;
    }

    const styleWrapper = clsx({
        [styles.imatgeWrapper]: true,
        [styles[estil]]: true,
        [styles[tema]]: true
    });

    return (
        <div className={styles.destacatObertura} {...(testId && { 'data-testid': testId })} role='article'>
            <Enllac
                route={{
                    type: 'web_actualitat_item_minutaminut',
                    id: id,
                    slug: permatitle || titol
                }}
                dataTestId='destacat-enllac'
                marcatgeAudienciesClick={marcatgeAudienciesClick}
            >
                <div className={styles.cos}>
                    <div className={styles.blurredimatge}>
                        <Imatge
                            imatges={imatges}
                            tipus='web_destacat'
                            alt=''
                            aria-hidden='true'
                            layout='fill'
                            objectFit='cover'
                            priority={priorityImage}
                            crop='1903'
                            data_testid='destacat-img'
                        />
                    </div>

                    <div className={styleWrapper} data-testid='destacat-content-imatge'>
                        <Imatge
                            imatges={imatges}
                            className={styles.imatge}
                            tipus='web_destacat'
                            aria-hidden='true'
                            layout='fill'
                            objectFit='cover'
                            priority={priorityImage}
                            crop='1903'
                            data_testid='destacat-img'
                        />
                        <div className={styles.textWrapper}>
                            {etiquetaEspecialBool && (
                                <div className={styles.etiquetaEspecialWrapper}>
                                    <EtiquetesEspecial agrupacions={agrupacions} tags={tags} id={id} />
                                </div>
                            )}
                            <div className={styles.labelWrapper}>
                                {isDirecte && (
                                    <Etiqueta
                                        className={styles.labelEtiqueta}
                                        text='En directe'
                                        icona='directes'
                                        isBlanc={true}
                                        tipus='highlight'
                                    />
                                )}
                                <Etiquetes agrupacions={agrupacions} id={id} />
                            </div>
                            <h3 className={styles.titol} data-testid='destacat-titol'>
                                <span dangerouslySetInnerHTML={{ __html: titol }}></span>
                            </h3>
                            {(!__isEmpty(autors) || !__isEmpty(lloc)) && (
                                <div className={styles.autorWrapper}>
                                    {!__isEmpty(autors) && (
                                        <span className={styles.autors}>
                                            {autors.map((item, i) => {
                                                const isFirst = i === 0 && autors.length > 1;
                                                const isLast = i === autors.length - 1;
                                                const routeAutor = {
                                                    slug: item?.nom,
                                                    id: item?.id,
                                                    tipologia: item?.tipologia
                                                };
                                                const href = getUrlFriendly({
                                                    producte: 'web_noticies',
                                                    ...routeAutor
                                                });
                                                return (
                                                    <Fragment key={'autor-' + item.id}>
                                                        {!isLast && !isFirst && ', '}
                                                        {isLast && autors.length > 1 && ' i '}
                                                        <button
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                e.preventDefault();
                                                                if (href) router.push(href);
                                                            }}
                                                            className={styles.enllacAutor}
                                                        >
                                                            {item.nom}
                                                        </button>
                                                    </Fragment>
                                                );
                                            })}
                                        </span>
                                    )}
                                    {!__isEmpty(lloc) && <span className={styles.lloc}>{lloc}</span>}
                                </div>
                            )}
                            <div className={styles.minutWrapper}>
                                <h4>Minut a minut</h4>
                                {!__isEmpty(entrades) && (
                                    <ul className={styles.timeLine}>
                                        {entrades.slice(0, 4).map((item, i) => {
                                            return (
                                                <li key={item.id}>
                                                    <time dateTime={getDataUTC(item.data_publicacio)}>
                                                        {getHora(item.data_publicacio)}
                                                    </time>
                                                    <Text text={item.titol} tag='p' />
                                                </li>
                                            );
                                        })}
                                    </ul>
                                )}
                                <Boto
                                    route={{
                                        type: 'web_actualitat_item_minutaminut',
                                        id: id,
                                        slug: permatitle || titol
                                    }}
                                    className={styles.botoMinut}
                                    text='Ves-hi ara'
                                    icona='fletxa_dreta'
                                    iconaInline={true}
                                    fons='fonsContenidorNegre'
                                    altIcona=''
                                    tag='button'
                                />
                            </div>
                        </div>
                    </div>
                    <DataPublicacio isDirecte={isDirecte} mostrarData={mostrarData} date={data_publicacio} />
                </div>
            </Enllac>
        </div>
    );
};

export default DestacatVisualMinut;
